export const httpErrorCodes = {
  BAD_REQUEST: '400',
  UNAUTHORIZED: '401',
  FORBIDDEN: '403',
  NOT_FOUND: '404',
  UNPROCESSABLE_ENTITY: '422',
  METHOD_NOT_ALLOWED: '405',
  INTERNAL_SERVER_ERROR: '500',
  SERVICE_UNAVAILABLE: '503',
};

export const pageName = {
  ACCOUNTS_PAGE: 'ACCOUNTS_PAGE',
  TEAMS_PAGE: 'TEAMS_PAGE',
  WORKSPACE_PAGE: 'WORKSPACE_PAGE',
  COHORT_OVERVIEW: 'COHORT_OVERVIEW',
  COHORT_PAGE:'COHORT_PAGE',
  COHORT_COURSEWARE_PAGE: 'COHORT_COURSEWARE_PAGE',
  ACTIVITY_EDITOR_PAGE: 'ACTIVITY_EDITOR_PAGE',
  OWNER_WORKSPACES_PAGE: 'OWNER_WORKSPACES_PAGE',
  ACTIVITY_BUILDER: 'ACTIVITY_BUILDER',
  COURSE_COMPETENCY_PAGE: 'COURSE_COMPETENCY_PAGE',
  COURSE_CONTENT_PAGE: 'COURSE_CONTENT_PAGE',
  COURSE_SCORING_PAGE: 'COURSE_SCORING_PAGE',
  KNOWLEDGE_BUILDER_PAGE: 'KNOWLEDGE_BUILDER_PAGE',
  CONTENT_PAGE: 'CONTENT_PAGE',
  LESSON_BUILDER_PAGE: 'LESSON_BUILDER_PAGE',
  SCREEN_EDITOR_PAGE: 'SCREEN_EDITOR_PAGE',
};


export const defaultGTMDataLayerPayload = {
  product_id: null, // NA 
  product_platform_code: 'BRONTE', // BRONTE
  product_model_name: 'BRONTE', // BRONTE,
  business_model_code: null, // directToLearner, courseWare
  secondary_person_id: null,
  secondary_person_id_type: null,
  secondary_person_role_code: null,
  person_id_type:'BRONTE-INTERNAL',
};

export const GTM_EVENT_TYPES = {
  PAGEVIEW: 'pageview',
  USER_INTERACTION: 'user_interaction',
  USER_EXCEPTION: 'user_exception',
  GLOBAL_LAUNCH: 'global_launch',
  GLOBAL_OBLIGATORY_LAUNCH: 'global_obligatory_launch', // login, logout
};


export const GTM_CDP_TRACK_PAGEVIEW_EVENT = "gtm.track.pageview.event";
export const GTM_CDP_TRACK_USER_INTERACTION_EVENT = "gtm.track.user.interaction.event";
export const GTM_CDP_TRACK_USER_EXCEPTION_EVENT = "gtm.track.user.exception.event";

export const GTM_CDP_EVENT_NAMES = [
  GTM_CDP_TRACK_PAGEVIEW_EVENT,
  GTM_CDP_TRACK_USER_INTERACTION_EVENT,
  GTM_CDP_TRACK_USER_EXCEPTION_EVENT,
];
